import { FONT } from "../../../value/staticValues";
import { getTimestampToDate, numberOfCommas, parseLocaleDatetime } from "../../../common/util";

import { ReactComponent as AddButtonImg } from "../../../img/ico-prefix-add.svg";
import { ReactComponent as AddButtonActiveImg } from "../../../img/ico-prefix-add-white.svg";

import { ReactComponent as StatusStableImg} from "../../../img/ico-status-stable.svg";
import { ReactComponent as StatusBlockImg } from "../../../img/ico-status-block.svg";

import { DropdownType } from "../../base/CustomDropdown";
import { ListActionMenu, ListFilter, ListTableHeader } from "../../base/table/listTableType";
import { TABLE_ACTION_MENU_TYPE, TABLE_BUTTON_TYPE } from "../../../value/type";

import i18n from "../../../lang/base";
import ProductOptionAdd from "./ProductOptionAdd";
import ProductOptionUpdate from "./ProductOptionUpdate";


export interface ProductData {
    product_id: string;
    product_name: string;
    product_description: string;
    product_type_code: string;
    base_price: number;
}

export interface ProductOptionData {
    product_option_id: string;
    product_option_name: string;
    product_option_description: string;
    product_option_type_code: string;
    product_option_target_code: string;
    option_price: number;
    option_count: number;
    create_ts: string;
    update_ts: string;

    product: ProductData;
}


export const actionMenus:ListActionMenu[] = [
    {
        id: 1,
        name: i18n.t("SERVICE_PRODUCT_OPTION_ADD_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.PUSH_WITH_ICON,
            code: "PRODUCT_OPTION_ADD",
            imgComponent: <AddButtonImg/> ,
            activeImgComponent: <AddButtonActiveImg />,
            inactiveImgComponent: <AddButtonImg style={{filter: "opacity(0.5) grayscale(0.5)"}}/>,
        },
    },
    {
        id: 2,
        name: i18n.t("DELETE_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.CANCEL,
            code: "PRODUCT_OPTION_DELETE",
        },
    },
];




export const tableHeaders:ListTableHeader[] = [
    {
        Header: i18n.t("SERVICE_PRODUCT_OPTION_NAME_TEXT"),
        accessor: "product_option_name",
        disableSortBy: false,
        style: {
            width: "140px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value}</div>)
    },
    {
        Header: i18n.t("SERVICE_PRODUCT_OPTION_DESCRIPTION_TEXT"),
        accessor: "product_option_description",
        disableSortBy: true,
        style: {
            
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value}</div>)
    },
    {
        Header: i18n.t("SERVICE_PRODUCT_OPTION_TYPE_TEXT"),
        accessor: "product_option_type_code",
        disableSortBy: false,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{
                display: "flex", alignItems: "center", justifyContent: "center",
                width: 90, height: 20,
                paddingLeft: 10, paddingRight: 10,
                borderRadius: 10,
                backgroundColor: value === "MTDEV" ? "#ddf2e8" : value === "MTUSR" ? "#faedf0" : value === "MTMON" ? "#eeecfc" : value === "UPSPT" ? "#e6ebf2" : value === "EXPDT" ? "#bfdeff" : "#fff187",
                fontFamily: FONT.REGULAR,
                fontSize: 12,
                color: value === "MTDEV" ? "#5b9782" : value === "MTUSR" ? "#ae4f5a" : value === "MTMON" ? "#806dc6" : value === "UPSPT" ? "#9ca3ad" : value === "EXPDT" ? "#5365b0" : "#8d7f36",
            }}>
                {
                    value === "MTDEV" ? "허용 장치"
                    : value === "MTUSR" ? "허용 세션"
                    : value === "MTMON" ? "허용 모니터"
                    : value === "UPSPT" ? "업그레이드 지원"
                    : value === "EXPDT" ? "사용 기간"
                    : "손쉬운 연결"
                }
            </div>
        )
    },
    {
        Header: i18n.t("SERVICE_PRODUCT_OPTION_PRICE_TEXT"),
        accessor: "option_price",
        disableSortBy: true,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer,...className.purpleText}}>
            {
                value > 0 ? numberOfCommas(value) + " 원" : "가격 협의"
            }
        </div>)
    },
    {
        Header: i18n.t("SERVICE_PRODUCT_OPTION_COUNT_TEXT"),
        accessor: "option_count",
        disableSortBy: true,
        style: {
            width: "80px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer,...className.greenText}}>
            {
                numberOfCommas(value)
            }
        </div>)
    },
    {
        Header: i18n.t("UPDATE_DATE_TEXT"),
        accessor: "update_ts",
        disableSortBy: false,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer}}>{value ? parseLocaleDatetime(value) : ""}</div>)
    },
    {
        Header: i18n.t("CREATE_DATE_TEXT"),
        accessor: "create_ts",
        disableSortBy: false,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer,...className.dateContainer}}>{value ? parseLocaleDatetime(value) : ""}</div>)
    },
];


export const productOptionAddModalContent = {
    title: i18n.t("SERVICE_PRODUCT_OPTION_CREATE_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("CREATE_TEXT")
        },
    ],
    innerComponent: <ProductOptionAdd />,
}

export const productOptionUpdateModalContent = {
    title: i18n.t("SERVICE_PRODUCT_OPTION_UPDATE_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("UPDATE_SAVE_TEXT")
        },
    ],
    innerComponent: <ProductOptionUpdate />,
}


export const ProductOptionTypeDropdownItem:DropdownType[] = [
    {
        value: "MTDEV",
        label: "허용 장치"
    },
    {
        value: "MTUSR",
        label: "허용 세션"
    },
    {
        value: "MTMON",
        label: "허용 모니터"
    },
    {
        value: "UPSPT",
        label: "업그레이드 지원"
    },
    {
        value: "EXPDT",
        label: "사용 기간"
    },
    {
        value: "ACBT",
        label: "손쉬운 연결"
    }
]

export const ProductOptionTargetDropdownItem:DropdownType[] = [
    {
        value: "RDSOPT",
        label: "RDS"
    },
    {
        value: "VDIOPT",
        label: "VDI"
    }
]

const className = {
    normalTextContainer: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333",
        overflow: "hidden"
    },
    statusImg: {
        marginRight: 3
    },
    dateContainer: {
        color: "#9ea0a5",
    },
    resourceContainer: {
        color: "#0853fb"
    },
    countContainer: {
        color: "#3a8344"
    },
    purpleText: {
        color: "#7066f1"
    },
    greenText: {
        color: "#3a8344"
    }
}
